export default {
  default: {
    manage: 'Manage',
    manageButton: 'Manage Reviews',
    title: 'Reviews',
  },
}
